// Generated from assets/icons/tt-hashtag-active.svg (TA-11013).
// Ids are derived per instance via useSvgIdPrefix() so two copies on one
// screen cannot collide. Edit this file rather than re-adding the .svg.
import * as React from 'react';
import Svg, { Path, Defs, LinearGradient, Stop } from 'react-native-svg';

import { useSvgIdPrefix } from '@hooks/useSvgIdPrefix';

import type { SvgProps } from 'react-native-svg';

export const TTHashtagActive = (props: SvgProps) => {
  const uid = useSvgIdPrefix();
  return (
    <Svg fill='none' viewBox='16 15 24 24' {...props}>
      <Path
        fill={`url(#${uid}-a)`}
        d='M18 27c0-4.714 0-7.071 1.464-8.536C20.93 17 23.286 17 28 17s7.071 0 8.535 1.464C38 19.93 38 22.286 38 27s0 7.071-1.465 8.535C35.072 37 32.714 37 28 37s-7.071 0-8.536-1.465C18 34.072 18 31.714 18 27'
      />
      <Path
        fill={`url(#${uid}-b)`}
        d='m25.867 28.833 1-3.333h4.166l-1 3.333z'
      />
      <Path
        stroke='#035B60'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='m27.617 23-2.5 8.333M31.783 23l-2.5 8.333M33.45 25.5h-9.167m8.334 3.333H23.45'
      />
      <Defs>
        <LinearGradient
          id={`${uid}-a`}
          x1={21.5}
          x2={43}
          y1={19.5}
          y2={42}
          gradientUnits='userSpaceOnUse'>
          <Stop stopColor='#97D8C6' />
          <Stop offset={1} stopColor='#32866F' />
        </LinearGradient>
        <LinearGradient
          id={`${uid}-b`}
          x1={25.2}
          x2={33.94}
          y1={24.042}
          y2={35.017}
          gradientUnits='userSpaceOnUse'>
          <Stop stopColor='#97D8C6' />
          <Stop offset={1} stopColor='#32866F' />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};
